import { all, fork } from "@redux-saga/core/effects";
import serviceRequestSaga from "./ServiceRequest/serviceRequestInfo";
import announcementSaga from "./Announcement/announcementRequestInfo";
import unitSaga from "./Unit/unitRequestInfo";
import bookingSaga from "./Booking/bookingRequestInfo";
import visitorParkingSaga from "./VisitorParking/visitorParkingRequestInfo";
import violationSaga from "./Violation/violationRequestInfo";
import userSaga from "./User/userRequestInfo";
import toDoSaga from "./ToDo/toDoRequestInfo";
import eventSaga from "./Event/eventRequestInfo";

function* rootSaga() {
  yield all([
    fork(serviceRequestSaga),
    fork(announcementSaga),
    fork(unitSaga),
    fork(bookingSaga),
    fork(visitorParkingSaga),
    fork(violationSaga),
    fork(userSaga),
    fork(toDoSaga),
    fork(eventSaga),
  ]);
}

export default rootSaga;

